












import Vue from 'vue';
import DonutChart from '../../../common/Chart/DonutChart.vue';

export default Vue.extend({
  components: {
    DonutChart,
  },
  data(): { colorsList: string[]; faultColorsList: string[] } {
    return {
      colorsList: ['#24BE99', '#5bd99c'],
      faultColorsList: ['#F8791D', '#FF974D', '#FBB500', '#FBCC38'],
    };
  },
  computed: {
    series(): number[] {
      return Object.values(this.$store.getters.extensionDistribution);
    },
    labels(): string[] {
      return Object.keys(this.$store.getters.extensionDistribution);
    },
    colors(): string[] {
      let colorIndex = -1;
      let faultColorIndex = -1;

      return this.labels.map((label) => {
        if (['png', 'jpg', 'bmp', 'jpeg', 'tiff'].includes(label)) {
          colorIndex = (colorIndex + 1) % this.colorsList.length;
          return this.colorsList[colorIndex];
        } else {
          faultColorIndex = (faultColorIndex + 1) % this.faultColorsList.length;
          return this.faultColorsList[faultColorIndex];
        }
      });
    },
  },
});
